// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__z3Act","expandIconWrapper":"CustomNode_expandIconWrapper__3h5M4","isOpen":"CustomNode_isOpen__3YqeU","labelGridItem":"CustomNode_labelGridItem__1NUwj"};